module.exports = __webpack_public_path__ + "img/branding02.30e3c2ad.jpg";